import { gatewayFetch } from './gateway.js';

const USER_STORAGE_KEY = 'mm_client_session';

export async function login(email, pin, filterKey = 'Handyman') {
  const cleanEmail = String(email).trim().toLowerCase();
  const cleanPin = String(pin).trim();

  if (!cleanEmail || !cleanPin) {
    throw new Error('Please enter both your email address and Access PIN.');
  }

  const endpoint = '/api/v1/public/auth/login';

  try {
    const data = await gatewayFetch(endpoint, {
      method: 'POST',
      body: JSON.stringify({
        email: cleanEmail,
        password: cleanPin,
        filter_key: filterKey
      })
    });

    if (!data || !data.access_token) {
      throw new Error(data?.detail || 'Invalid email or Access PIN.');
    }

    const userProfile = {
      id: data.user_id || 'client_session',
      agencyName: data.agency_name || data.agencyName || 'Client',
      authEmail: cleanEmail,
      filterKey: data.filter_key || filterKey,
      companyNumber: data.companyNumber || data.company_number || '',
      billingAddress: data.billingAddress || data.billing_address || '',
      token: data.access_token
    };

    localStorage.setItem('access_token', data.access_token);
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(userProfile));

    return userProfile;
  } catch (error) {
    console.error('Public Edge Auth Error:', error);
    throw new Error(error.message || 'Authentication failed.');
  }
}

export async function registerClient(formData) {
  const firstName = String(formData.firstName || '').trim();
  const lastName = String(formData.lastName || '').trim();
  const email = String(formData.email || '').trim().toLowerCase();
  const phone = String(formData.phone || '').trim();
  const companyName = String(formData.companyName || `${firstName}'s Agency`).trim();
  const billingAddress = String(formData.billingAddress || '').trim();

  if (!firstName || !email) {
    throw new Error('First Name and Email Address are required.');
  }

  return await gatewayFetch('/api/v1/public/auth/register', {
    method: 'POST',
    body: JSON.stringify({
      firstName,
      lastName,
      email,
      phone,
      companyName,
      billingAddress
    })
  });
}

export function getCurrentUser() {
  const session = localStorage.getItem(USER_STORAGE_KEY);
  if (!session) return null;
  try {
    return JSON.parse(session);
  } catch (err) {
    logout();
    return null;
  }
}

export function isAuthenticated() {
  return !!getCurrentUser();
}

export function logout() {
  localStorage.removeItem(USER_STORAGE_KEY);
  localStorage.removeItem('access_token');
}